import React from "react";
import PropTypes from "prop-types";
import Input from "@mui/material/Input";
import { useState } from "react";
import { InputAdornment } from "@mui/material";
import { IconButton } from "@mui/material";
import { Visibility } from "@mui/icons-material";
import { VisibilityOff } from "@mui/icons-material";

function SimplePasswordFieldMUI(props) {
  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  return (
    <Input
      id={props.id}
      size="small"
      variant="filled"
      type={showPassword ? "text" : "password"}
      endAdornment={
        <InputAdornment
          position="end"
          sx={{
            height: "19px",
            backgroundColor: props.backgroundColor
              ? props.backgroundColor
              : "white",
            margin: "0px",
            padding: "1px 3px",
          }}
        >
          <IconButton
            size="small"
            onClick={handleClickShowPassword}
            onMouseDown={handleMouseDownPassword}
          >
            {showPassword ? <VisibilityOff /> : <Visibility />}
          </IconButton>
        </InputAdornment>
      }
      value={props.value}
      //margin="dense"
      onChange={props.onChange}
      onKeyDown={props.handleKeyPress}
      sx={{
        "& .css-nz481w-MuiInputBase-input-MuiInput-input": {
          padding: "1px 5px",
          fontSize: "0.85em",
          backgroundColor: props.backgroundColor
            ? props.backgroundColor
            : "white",
        },
        "& .css-78trlr-MuiButtonBase-root-MuiIconButton-root": {
          padding: "1px 5px",
          fontSize: "0.85em",
          backgroundColor: props.backgroundColor
            ? props.backgroundColor
            : "white",
        },
        padding: "1px 5px",
        margin: "3px 1px",
        width: "65%",
        height: "20px",
      }}
    />
  );
}

export default SimplePasswordFieldMUI;

SimplePasswordFieldMUI.propTypes = {
  id: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  width: PropTypes.string,
  backgroundColor: PropTypes.string,
  type: PropTypes.string,
  handleKeyPress: PropTypes.func,
};
